import { useTranslation } from 'react-i18next';
import { CategoryItem, DestinationItem, ResponsibleItem } from '../types/budget';
import { changeLanguage, getCurrentLanguage } from '../i18n';
import { useEffect } from 'react';

export const useI18n = () => {
  const { t, i18n } = useTranslation();

  // Get the current language
  const currentLanguage = getCurrentLanguage();

  // Change language function
  const switchLanguage = (language: string) => {
    changeLanguage(language);
  };

  // Initialize i18n when the component mounts
  useEffect(() => {
    // If there's a stored language preference, use it
    const storedLanguage = localStorage.getItem('budget_app_language');
    if (storedLanguage) {
      i18n.changeLanguage(storedLanguage);
    }
  }, [i18n]);

  const categories: CategoryItem[] = [
    { id: 'subscription', name: t('defaults.categories.subscription') },
    { id: 'others', name: t('defaults.categories.others') },
    { id: 'groceries', name: t('defaults.categories.groceries') },
    { id: 'dividends', name: t('defaults.categories.dividends') },
    { id: 'children', name: t('defaults.categories.children') },
    { id: 'cash', name: t('defaults.categories.cash') },
    { id: 'fees', name: t('defaults.categories.fees') },
    { id: 'house', name: t('defaults.categories.house') },
    { id: 'expense-report', name: t('defaults.categories.expense-report') },
    { id: 'salary', name: t('defaults.categories.salary') },
    { id: 'health', name: t('defaults.categories.health') },
    { id: 'transport', name: t('defaults.categories.transport') },
  ];

  const responsibles: ResponsibleItem[] = [
    { id: 'common', name: t('defaults.responsibles.common'), isProtected: true },
  ];

  const destinations: DestinationItem[] = [
    { id: 'cash', name: t('defaults.destinations.cash'), isProtected: true },
  ];

  return {
    t,
    i18n,
    currentLanguage,
    switchLanguage,
    defaults: {
      categories,
      responsibles,
      destinations,
    },
  };
};
